export const PageNotFoundMessage = {
    pageNotFoundMessages: {
        TITLE: '¡Ups! Página no encontrada',
        SUBTITLE: 'Página no encontrada',
        MESSAGE: '¡Lo sentimos pero no se encontró la página que solicitas!',
    },
};
